const TOKEN_KEY = "tk";
const USER_INFO_KEY = "ui";

export default {
  create: storage => {
    return {
      hasTokenStored: () => {
        return storage.getItem(USER_INFO_KEY) !== null && storage.getItem(TOKEN_KEY) != null;
      },

      getToken: () => {
        return storage.getItem(TOKEN_KEY);
      },

      setToken: () => {
        storage.getItem(TOKEN_KEY);
      },

      getUserData: () => {
        return JSON.parse(storage.getItem(USER_INFO_KEY));
      },

      setUserData: datos => {
        storage.setItem(USER_INFO_KEY, JSON.stringify(datos));
      },

      guardar: (token, datos) => {
        storage.setItem(TOKEN_KEY, token);
        storage.setItem(USER_INFO_KEY, JSON.stringify(datos));
      },
      borrar: () => {
        storage.removeItem(TOKEN_KEY);
        storage.removeItem(USER_INFO_KEY);
      }
    };
  }
};
